import { useQuery } from "react-query";
import { useRecoilValue } from "recoil";
import { getPendingNavBadge } from "../datasource/CustomerTierProgramDatasource";
import { checkPermission } from "../components/Permission/Permission";
import { roleAtom } from "../store/RoleAtom";

// Invalidate this key after a Navision status change so the sidebar dot refreshes.
export const SHOP_TIER_PENDING_NAV_QUERY_KEY = "shop-tier-pending-nav";

/**
 * Whether the "ระดับร้านค้า" sidebar item shows its orange dot (shops whose tier changed but
 * are not keyed into Navision yet). Checked once each time the sidebar mounts — i.e. once per
 * login — not on every route change.
 */
function useShopTierPendingNav(): boolean {
  const roleData = useRecoilValue(roleAtom);
  const canView = checkPermission(["shopTier"], roleData);
  const company: string | undefined = JSON.parse(localStorage.getItem("profile") || "null")?.company;

  const { data } = useQuery(
    [SHOP_TIER_PENDING_NAV_QUERY_KEY, company],
    () => getPendingNavBadge(company as string),
    {
      enabled: canView && !!company,
      staleTime: Infinity,
      refetchOnMount: "always",
      refetchOnWindowFocus: false,
    },
  );

  return (data?.responseData?.isPendingNav);
}

export default useShopTierPendingNav;
